<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="card">
                    <div class="header text-center">
                        <h4 class="title">LBD Angular CLI PRO</h4>
                        <p class="category">Looking for more components? Please check our Premium Version of Light Bootstrap Dashboard.</p>
                        <br>
                    </div>
                    <div class="content table-responsive table-full-width table-upgrade">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-center">Free</th>
                                    <th class="text-center">PRO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Components</td>
                                    <td>16</td>
                                    <td>115+</td>
                                </tr>
                                <tr>
                                    <td>Plugins</td>
                                    <td>4</td>
                                    <td>14+</td>
                                </tr>
                                <tr>
                                    <td>Example Pages</td>
                                    <td>4</td>
                                    <td>22+</td>
                                </tr>
                                <tr>
                                    <td>Documentation</td>
                                    <td>
                                        <i class="fa fa-times text-danger"></i>
                                    </td>
                                    <td>
                                        <i class="fa fa-check text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td>SASS Files</td>
                                    <td><i class="fa fa-times text-danger"></i></td>
                                    <td><i class="fa fa-check text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Login/Register/Lock Pages</td>
                                    <td><i class="fa fa-times text-danger"></i></td>
                                    <td><i class="fa fa-check text-success"></i></td>
                                </tr>
                                <tr>
                                    <td>Premium Support</td>
                                    <td><i class="fa fa-times text-danger"></i></td>
                                    <td><i class="fa fa-check text-success"></i></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>Free</td>
                                    <td>Just $49</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <a href="#" class="btn btn-round btn-fill btn-default disabled">Current Version</a>
                                    </td>
                                    <td>
                                        <a target="_blank" href="https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-angular2/?ref=lbd-angular2-free" class="btn btn-round btn-fill btn-info">Upgrade to PRO</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
